function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInspect = function SvgInspect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 15 15"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.504 6.746h8.062v1.469H7.97v6.351H6.504ZM.395.395h1.527v1.464h-.063v.063H.395Zm4.703 1.464H3.512V.395h1.586Zm3.175 0H6.688V.395h1.585Zm3.176 0H9.863V.395h1.586Zm1.649 0h-.059V.395h1.527v1.71h-1.468ZM1.859 3.512v1.586H.395V3.512Zm11.239 1.523V4.06h1.468v.976ZM1.859 6.687v1.586H.395V6.688Zm0 3.176v1.586H.395V9.863Zm.246 4.703H.395V13.04h1.464v.059h.246Zm1.954-1.468h.976v1.468H4.06Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#6e6e6e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.57 14.605 7.46 8.742l1.017-1.058 6.109 5.863Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#6e6e6e",
      fillOpacity: 1
    }
  }));
};
export default SvgInspect;